import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../lib/firebase';

// Database structure: vindie/{collection}

export interface UserProfile {
  uid: string;
  username?: string;
  name?: string;
  email?: string;
  avatarUrl?: string;
  bio?: string;
  language?: string;
  location?: string;
  age?: number;
  gender?: string;
  phoneNumber?: string;
  backupEmail?: string;
  isPhoneVerified?: boolean;
  isEmailVerified?: boolean;
  // Subscription fields
  subscriptionTier?: string;
  subscriptionStatus?: 'active' | 'cancelled' | 'expired' | 'pending';
  subscriptionEndDate?: any;
  creatorBadge?: {
    tier: 'bronze' | 'silver' | 'gold' | 'platinum';
    name: string;
    color: string;
  };
  isAdFree?: boolean;
  createdAt?: any;
  updatedAt?: any;
}

export async function getUserProfile(uid: string): Promise<UserProfile | null> {
  const ref = doc(db, 'users', uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return snap.data() as UserProfile;
}

export async function createUserProfile(profile: UserProfile) {
  const ref = doc(db, 'users', profile.uid);
  await setDoc(ref, { ...profile, createdAt: serverTimestamp(), updatedAt: serverTimestamp() }, { merge: true });
}

export async function updateUserProfile(uid: string, updates: Partial<UserProfile>) {
  const ref = doc(db, 'users', uid);
  await updateDoc(ref, { ...updates, updatedAt: serverTimestamp() });
}


